export default __webpack_public_path__ + "static/ImmoScout24-edf953b97f9147d7cfa426ace800b382.svg";